module.exports = __webpack_public_path__ + "static/media/webmoney-dark.5c559c4c.svg";